var map = {
	"./ad.svg": "./assets/images/flags/ad.svg",
	"./ae.svg": "./assets/images/flags/ae.svg",
	"./af.svg": "./assets/images/flags/af.svg",
	"./ag.svg": "./assets/images/flags/ag.svg",
	"./ai.svg": "./assets/images/flags/ai.svg",
	"./al.svg": "./assets/images/flags/al.svg",
	"./am.svg": "./assets/images/flags/am.svg",
	"./ao.svg": "./assets/images/flags/ao.svg",
	"./aq.svg": "./assets/images/flags/aq.svg",
	"./ar.svg": "./assets/images/flags/ar.svg",
	"./as.svg": "./assets/images/flags/as.svg",
	"./at.svg": "./assets/images/flags/at.svg",
	"./au.svg": "./assets/images/flags/au.svg",
	"./aw.svg": "./assets/images/flags/aw.svg",
	"./ax.svg": "./assets/images/flags/ax.svg",
	"./az.svg": "./assets/images/flags/az.svg",
	"./ba.svg": "./assets/images/flags/ba.svg",
	"./bb.svg": "./assets/images/flags/bb.svg",
	"./bd.svg": "./assets/images/flags/bd.svg",
	"./be.svg": "./assets/images/flags/be.svg",
	"./bf.svg": "./assets/images/flags/bf.svg",
	"./bg.svg": "./assets/images/flags/bg.svg",
	"./bh.svg": "./assets/images/flags/bh.svg",
	"./bi.svg": "./assets/images/flags/bi.svg",
	"./bj.svg": "./assets/images/flags/bj.svg",
	"./bl.svg": "./assets/images/flags/bl.svg",
	"./bm.svg": "./assets/images/flags/bm.svg",
	"./bn.svg": "./assets/images/flags/bn.svg",
	"./bo.svg": "./assets/images/flags/bo.svg",
	"./bq-bo.svg": "./assets/images/flags/bq-bo.svg",
	"./bq-sa.svg": "./assets/images/flags/bq-sa.svg",
	"./bq-se.svg": "./assets/images/flags/bq-se.svg",
	"./bq.svg": "./assets/images/flags/bq.svg",
	"./br.svg": "./assets/images/flags/br.svg",
	"./bs.svg": "./assets/images/flags/bs.svg",
	"./bt.svg": "./assets/images/flags/bt.svg",
	"./bv.svg": "./assets/images/flags/bv.svg",
	"./bw.svg": "./assets/images/flags/bw.svg",
	"./by.svg": "./assets/images/flags/by.svg",
	"./bz.svg": "./assets/images/flags/bz.svg",
	"./ca-bc.svg": "./assets/images/flags/ca-bc.svg",
	"./ca.svg": "./assets/images/flags/ca.svg",
	"./cc.svg": "./assets/images/flags/cc.svg",
	"./cd.svg": "./assets/images/flags/cd.svg",
	"./cf.svg": "./assets/images/flags/cf.svg",
	"./cg.svg": "./assets/images/flags/cg.svg",
	"./ch.svg": "./assets/images/flags/ch.svg",
	"./ci.svg": "./assets/images/flags/ci.svg",
	"./ck.svg": "./assets/images/flags/ck.svg",
	"./cl.svg": "./assets/images/flags/cl.svg",
	"./cm.svg": "./assets/images/flags/cm.svg",
	"./cn.svg": "./assets/images/flags/cn.svg",
	"./co.svg": "./assets/images/flags/co.svg",
	"./cr.svg": "./assets/images/flags/cr.svg",
	"./cu.svg": "./assets/images/flags/cu.svg",
	"./cv.svg": "./assets/images/flags/cv.svg",
	"./cw.svg": "./assets/images/flags/cw.svg",
	"./cx.svg": "./assets/images/flags/cx.svg",
	"./cy.svg": "./assets/images/flags/cy.svg",
	"./cz.svg": "./assets/images/flags/cz.svg",
	"./de.svg": "./assets/images/flags/de.svg",
	"./dj.svg": "./assets/images/flags/dj.svg",
	"./dk.svg": "./assets/images/flags/dk.svg",
	"./dm.svg": "./assets/images/flags/dm.svg",
	"./do.svg": "./assets/images/flags/do.svg",
	"./dz.svg": "./assets/images/flags/dz.svg",
	"./easter_island.svg": "./assets/images/flags/easter_island.svg",
	"./ec-w.svg": "./assets/images/flags/ec-w.svg",
	"./ec.svg": "./assets/images/flags/ec.svg",
	"./ee.svg": "./assets/images/flags/ee.svg",
	"./eg.svg": "./assets/images/flags/eg.svg",
	"./eh.svg": "./assets/images/flags/eh.svg",
	"./er.svg": "./assets/images/flags/er.svg",
	"./es-ce.svg": "./assets/images/flags/es-ce.svg",
	"./es-cn.svg": "./assets/images/flags/es-cn.svg",
	"./es-ga.svg": "./assets/images/flags/es-ga.svg",
	"./es-ib.svg": "./assets/images/flags/es-ib.svg",
	"./es-ml.svg": "./assets/images/flags/es-ml.svg",
	"./es-pv.svg": "./assets/images/flags/es-pv.svg",
	"./es-variant.svg": "./assets/images/flags/es-variant.svg",
	"./es.svg": "./assets/images/flags/es.svg",
	"./esperanto.svg": "./assets/images/flags/esperanto.svg",
	"./et.svg": "./assets/images/flags/et.svg",
	"./eur.svg": "./assets/images/flags/eur.svg",
	"./european_union.svg": "./assets/images/flags/european_union.svg",
	"./fi.svg": "./assets/images/flags/fi.svg",
	"./fj.svg": "./assets/images/flags/fj.svg",
	"./fk.svg": "./assets/images/flags/fk.svg",
	"./fm.svg": "./assets/images/flags/fm.svg",
	"./fo.svg": "./assets/images/flags/fo.svg",
	"./fr-h.svg": "./assets/images/flags/fr-h.svg",
	"./fr.svg": "./assets/images/flags/fr.svg",
	"./ga.svg": "./assets/images/flags/ga.svg",
	"./gb-eng.svg": "./assets/images/flags/gb-eng.svg",
	"./gb-ork.svg": "./assets/images/flags/gb-ork.svg",
	"./gb-sct.svg": "./assets/images/flags/gb-sct.svg",
	"./gb-wls.svg": "./assets/images/flags/gb-wls.svg",
	"./gb.svg": "./assets/images/flags/gb.svg",
	"./gd.svg": "./assets/images/flags/gd.svg",
	"./ge-ab.svg": "./assets/images/flags/ge-ab.svg",
	"./ge.svg": "./assets/images/flags/ge.svg",
	"./gf.svg": "./assets/images/flags/gf.svg",
	"./gg.svg": "./assets/images/flags/gg.svg",
	"./gh.svg": "./assets/images/flags/gh.svg",
	"./gi.svg": "./assets/images/flags/gi.svg",
	"./gl.svg": "./assets/images/flags/gl.svg",
	"./gm.svg": "./assets/images/flags/gm.svg",
	"./gn.svg": "./assets/images/flags/gn.svg",
	"./gp.svg": "./assets/images/flags/gp.svg",
	"./gq.svg": "./assets/images/flags/gq.svg",
	"./gr.svg": "./assets/images/flags/gr.svg",
	"./gs.svg": "./assets/images/flags/gs.svg",
	"./gt.svg": "./assets/images/flags/gt.svg",
	"./gu.svg": "./assets/images/flags/gu.svg",
	"./gw.svg": "./assets/images/flags/gw.svg",
	"./gy.svg": "./assets/images/flags/gy.svg",
	"./hausa.svg": "./assets/images/flags/hausa.svg",
	"./hk.svg": "./assets/images/flags/hk.svg",
	"./hm.svg": "./assets/images/flags/hm.svg",
	"./hmong.svg": "./assets/images/flags/hmong.svg",
	"./hn.svg": "./assets/images/flags/hn.svg",
	"./hr.svg": "./assets/images/flags/hr.svg",
	"./ht.svg": "./assets/images/flags/ht.svg",
	"./hu.svg": "./assets/images/flags/hu.svg",
	"./id.svg": "./assets/images/flags/id.svg",
	"./ie.svg": "./assets/images/flags/ie.svg",
	"./il.svg": "./assets/images/flags/il.svg",
	"./im.svg": "./assets/images/flags/im.svg",
	"./in.svg": "./assets/images/flags/in.svg",
	"./io.svg": "./assets/images/flags/io.svg",
	"./iq.svg": "./assets/images/flags/iq.svg",
	"./ir.svg": "./assets/images/flags/ir.svg",
	"./is.svg": "./assets/images/flags/is.svg",
	"./it-82.svg": "./assets/images/flags/it-82.svg",
	"./it-88.svg": "./assets/images/flags/it-88.svg",
	"./it.svg": "./assets/images/flags/it.svg",
	"./je.svg": "./assets/images/flags/je.svg",
	"./jm.svg": "./assets/images/flags/jm.svg",
	"./jo.svg": "./assets/images/flags/jo.svg",
	"./jp.svg": "./assets/images/flags/jp.svg",
	"./kannada.svg": "./assets/images/flags/kannada.svg",
	"./ke.svg": "./assets/images/flags/ke.svg",
	"./kg.svg": "./assets/images/flags/kg.svg",
	"./kh.svg": "./assets/images/flags/kh.svg",
	"./ki.svg": "./assets/images/flags/ki.svg",
	"./km.svg": "./assets/images/flags/km.svg",
	"./kn.svg": "./assets/images/flags/kn.svg",
	"./kp.svg": "./assets/images/flags/kp.svg",
	"./kr.svg": "./assets/images/flags/kr.svg",
	"./kurdistan.svg": "./assets/images/flags/kurdistan.svg",
	"./kw.svg": "./assets/images/flags/kw.svg",
	"./ky.svg": "./assets/images/flags/ky.svg",
	"./kz.svg": "./assets/images/flags/kz.svg",
	"./la.svg": "./assets/images/flags/la.svg",
	"./lb.svg": "./assets/images/flags/lb.svg",
	"./lc.svg": "./assets/images/flags/lc.svg",
	"./li.svg": "./assets/images/flags/li.svg",
	"./lk.svg": "./assets/images/flags/lk.svg",
	"./lr.svg": "./assets/images/flags/lr.svg",
	"./ls.svg": "./assets/images/flags/ls.svg",
	"./lt.svg": "./assets/images/flags/lt.svg",
	"./lu.svg": "./assets/images/flags/lu.svg",
	"./lv.svg": "./assets/images/flags/lv.svg",
	"./ly.svg": "./assets/images/flags/ly.svg",
	"./ma.svg": "./assets/images/flags/ma.svg",
	"./malayali.svg": "./assets/images/flags/malayali.svg",
	"./maori.svg": "./assets/images/flags/maori.svg",
	"./mc.svg": "./assets/images/flags/mc.svg",
	"./md.svg": "./assets/images/flags/md.svg",
	"./me.svg": "./assets/images/flags/me.svg",
	"./mf.svg": "./assets/images/flags/mf.svg",
	"./mg.svg": "./assets/images/flags/mg.svg",
	"./mh.svg": "./assets/images/flags/mh.svg",
	"./mk.svg": "./assets/images/flags/mk.svg",
	"./ml.svg": "./assets/images/flags/ml.svg",
	"./mm.svg": "./assets/images/flags/mm.svg",
	"./mn.svg": "./assets/images/flags/mn.svg",
	"./mo.svg": "./assets/images/flags/mo.svg",
	"./mp.svg": "./assets/images/flags/mp.svg",
	"./mq.svg": "./assets/images/flags/mq.svg",
	"./mr.svg": "./assets/images/flags/mr.svg",
	"./ms.svg": "./assets/images/flags/ms.svg",
	"./mt.svg": "./assets/images/flags/mt.svg",
	"./mu.svg": "./assets/images/flags/mu.svg",
	"./mv.svg": "./assets/images/flags/mv.svg",
	"./mw.svg": "./assets/images/flags/mw.svg",
	"./mx.svg": "./assets/images/flags/mx.svg",
	"./my.svg": "./assets/images/flags/my.svg",
	"./mz.svg": "./assets/images/flags/mz.svg",
	"./na.svg": "./assets/images/flags/na.svg",
	"./nato.svg": "./assets/images/flags/nato.svg",
	"./nc.svg": "./assets/images/flags/nc.svg",
	"./ne.svg": "./assets/images/flags/ne.svg",
	"./nf.svg": "./assets/images/flags/nf.svg",
	"./ng.svg": "./assets/images/flags/ng.svg",
	"./ni.svg": "./assets/images/flags/ni.svg",
	"./nl.svg": "./assets/images/flags/nl.svg",
	"./no.svg": "./assets/images/flags/no.svg",
	"./northern_cyprus.svg": "./assets/images/flags/northern_cyprus.svg",
	"./np.svg": "./assets/images/flags/np.svg",
	"./nr.svg": "./assets/images/flags/nr.svg",
	"./nu.svg": "./assets/images/flags/nu.svg",
	"./nz.svg": "./assets/images/flags/nz.svg",
	"./om.svg": "./assets/images/flags/om.svg",
	"./pa.svg": "./assets/images/flags/pa.svg",
	"./pe.svg": "./assets/images/flags/pe.svg",
	"./pf.svg": "./assets/images/flags/pf.svg",
	"./pg.svg": "./assets/images/flags/pg.svg",
	"./ph.svg": "./assets/images/flags/ph.svg",
	"./pk.svg": "./assets/images/flags/pk.svg",
	"./pl.svg": "./assets/images/flags/pl.svg",
	"./pm.svg": "./assets/images/flags/pm.svg",
	"./pn.svg": "./assets/images/flags/pn.svg",
	"./pr.svg": "./assets/images/flags/pr.svg",
	"./ps.svg": "./assets/images/flags/ps.svg",
	"./pt-20.svg": "./assets/images/flags/pt-20.svg",
	"./pt-30.svg": "./assets/images/flags/pt-30.svg",
	"./pt.svg": "./assets/images/flags/pt.svg",
	"./pw.svg": "./assets/images/flags/pw.svg",
	"./py.svg": "./assets/images/flags/py.svg",
	"./qa.svg": "./assets/images/flags/qa.svg",
	"./re.svg": "./assets/images/flags/re.svg",
	"./ro.svg": "./assets/images/flags/ro.svg",
	"./rs.svg": "./assets/images/flags/rs.svg",
	"./ru.svg": "./assets/images/flags/ru.svg",
	"./rw.svg": "./assets/images/flags/rw.svg",
	"./sa.svg": "./assets/images/flags/sa.svg",
	"./sb.svg": "./assets/images/flags/sb.svg",
	"./sc.svg": "./assets/images/flags/sc.svg",
	"./sd.svg": "./assets/images/flags/sd.svg",
	"./se.svg": "./assets/images/flags/se.svg",
	"./sg.svg": "./assets/images/flags/sg.svg",
	"./sh-ac.svg": "./assets/images/flags/sh-ac.svg",
	"./sh-hl.svg": "./assets/images/flags/sh-hl.svg",
	"./sh-ta.svg": "./assets/images/flags/sh-ta.svg",
	"./sh.svg": "./assets/images/flags/sh.svg",
	"./si.svg": "./assets/images/flags/si.svg",
	"./sindh.svg": "./assets/images/flags/sindh.svg",
	"./sj.svg": "./assets/images/flags/sj.svg",
	"./sk.svg": "./assets/images/flags/sk.svg",
	"./sl.svg": "./assets/images/flags/sl.svg",
	"./sm.svg": "./assets/images/flags/sm.svg",
	"./sn.svg": "./assets/images/flags/sn.svg",
	"./so.svg": "./assets/images/flags/so.svg",
	"./somaliland.svg": "./assets/images/flags/somaliland.svg",
	"./south_ossetia.svg": "./assets/images/flags/south_ossetia.svg",
	"./sr.svg": "./assets/images/flags/sr.svg",
	"./ss.svg": "./assets/images/flags/ss.svg",
	"./st.svg": "./assets/images/flags/st.svg",
	"./sv.svg": "./assets/images/flags/sv.svg",
	"./sx.svg": "./assets/images/flags/sx.svg",
	"./sy.svg": "./assets/images/flags/sy.svg",
	"./sz.svg": "./assets/images/flags/sz.svg",
	"./tc.svg": "./assets/images/flags/tc.svg",
	"./td.svg": "./assets/images/flags/td.svg",
	"./tf.svg": "./assets/images/flags/tf.svg",
	"./tg.svg": "./assets/images/flags/tg.svg",
	"./th.svg": "./assets/images/flags/th.svg",
	"./tibet.svg": "./assets/images/flags/tibet.svg",
	"./tj.svg": "./assets/images/flags/tj.svg",
	"./tk.svg": "./assets/images/flags/tk.svg",
	"./tl.svg": "./assets/images/flags/tl.svg",
	"./tm.svg": "./assets/images/flags/tm.svg",
	"./tn.svg": "./assets/images/flags/tn.svg",
	"./to.svg": "./assets/images/flags/to.svg",
	"./tr.svg": "./assets/images/flags/tr.svg",
	"./transnistria.svg": "./assets/images/flags/transnistria.svg",
	"./tt.svg": "./assets/images/flags/tt.svg",
	"./tv.svg": "./assets/images/flags/tv.svg",
	"./tw.svg": "./assets/images/flags/tw.svg",
	"./tz.svg": "./assets/images/flags/tz.svg",
	"./ua.svg": "./assets/images/flags/ua.svg",
	"./ug.svg": "./assets/images/flags/ug.svg",
	"./um.svg": "./assets/images/flags/um.svg",
	"./united_nations.svg": "./assets/images/flags/united_nations.svg",
	"./us-hi.svg": "./assets/images/flags/us-hi.svg",
	"./us.svg": "./assets/images/flags/us.svg",
	"./uy.svg": "./assets/images/flags/uy.svg",
	"./uz.svg": "./assets/images/flags/uz.svg",
	"./va.svg": "./assets/images/flags/va.svg",
	"./vc.svg": "./assets/images/flags/vc.svg",
	"./ve.svg": "./assets/images/flags/ve.svg",
	"./vg.svg": "./assets/images/flags/vg.svg",
	"./vi.svg": "./assets/images/flags/vi.svg",
	"./vixio.svg": "./assets/images/flags/vixio.svg",
	"./vixiocircleflag.svg": "./assets/images/flags/vixiocircleflag.svg",
	"./vn.svg": "./assets/images/flags/vn.svg",
	"./vu.svg": "./assets/images/flags/vu.svg",
	"./wf.svg": "./assets/images/flags/wf.svg",
	"./ws.svg": "./assets/images/flags/ws.svg",
	"./xk.svg": "./assets/images/flags/xk.svg",
	"./xx.svg": "./assets/images/flags/xx.svg",
	"./ye.svg": "./assets/images/flags/ye.svg",
	"./yiddish.svg": "./assets/images/flags/yiddish.svg",
	"./yt.svg": "./assets/images/flags/yt.svg",
	"./za.svg": "./assets/images/flags/za.svg",
	"./zm.svg": "./assets/images/flags/zm.svg",
	"./zw.svg": "./assets/images/flags/zw.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/images/flags sync recursive ^\\.\\/.*\\.svg$";